import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";
import { WorkspaceProvider } from "./contexts/WorkspaceContext";
import { MeetingProvider } from "./contexts/MeetingContext";
import { MediasoupClientProvider } from "./contexts/MediasoupClientContext";

const root = ReactDOM.createRoot(document.getElementById("root-app"));
root.render(
  // <React.StrictMode>
  <ThemeProvider>
    <AuthProvider>
      <WorkspaceProvider>
        <MeetingProvider>
          <MediasoupClientProvider>
            <App />
          </MediasoupClientProvider>
        </MeetingProvider>
      </WorkspaceProvider>
    </AuthProvider>
  </ThemeProvider>
  // </React.StrictMode>
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        console.log("[SW] Registered, scope:", reg.scope);

        const sendSkipWaiting = () => {
          if (reg.waiting) reg.waiting.postMessage({ type: "SKIP_WAITING" });
        };

        sendSkipWaiting();

        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              console.log("[SW] Mise à jour disponible, activation…");
              sendSkipWaiting();
            }
          });
        });

        let refreshing = false;
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (refreshing) return;
          refreshing = true;
          window.location.reload();
        });
      })
      .catch((err) => {
        console.warn("[SW] Registration failed:", err.message);
      });
  });
}
